let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ZGPmR")).then(() => parcelRequire('gQG16'));